"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hookHeight = void 0;
var react_1 = require("react");
var getHeight = function () {
    return window.innerHeight ||
        document.body.clientHeight ||
        document.documentElement.clientHeight;
};
/**
 * Get height on resize
 */
var hookHeight = function () {
    var _a = react_1.useState(getHeight()), height = _a[0], setHeight = _a[1];
    // Get height on init
    react_1.useEffect(function () {
        getHeight();
    }, []);
    react_1.useEffect(function () {
        var listenToResizeEvent = function () {
            setHeight(getHeight());
        };
        window.addEventListener("resize", listenToResizeEvent);
        return function () {
            window.removeEventListener("resize", listenToResizeEvent);
        };
    }, []);
    return height;
};
exports.hookHeight = hookHeight;
